import { c as _c } from "react/compiler-runtime";
import React from "react";
const PartnerWithUsSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full max-w-xl mt-8"><div className="flex items-center justify-between mb-4">{[1, 2, 3].map(_temp)}</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex justify-between space-x-3 lg:w-[500px] max-w-xl w-full pb-8 pt-4">{[1, 2, 3].map(_temp2)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-full flex flex-col items-center justify-center space-y-4 animate-pulse pt-4">{t0}{t1}<div className="w-full space-y-6 pt-4"><div className="h-10 w-full bg-gray-100 rounded-lg" /><div className="h-10 w-full bg-gray-100 rounded-lg" /><div className="h-10 w-full bg-gray-100 rounded-lg" /><div className="h-10 w-full bg-gray-100 rounded-lg" /><div className="h-12 w-full bg-gray-200 rounded-lg mt-8" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default PartnerWithUsSkeleton;
function _temp(i) {
  return <div key={i} className="flex items-center"><div className="flex flex-col items-center"><div className="w-8 h-8 rounded-full bg-gray-200" /><div className="w-16 h-3 bg-gray-200 rounded mt-2" /></div>{i < 3 && <div className="w-4 h-4 mx-2 bg-gray-100 rounded" />}</div>;
}
function _temp2(s) {
  return <div key={s} className="w-1/3 h-1 bg-gray-200 rounded-lg" />;
}